import { __rest, __assign } from './../../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import Card from './Card.js';
import { Wrapper } from './styles.js';

var MAX_VISIBLE_ITEMS = 3;
var Table = forwardRef(function (_a, ref) {
    var rows = _a.rows, columns = _a.columns, _b = _a.seeMoreInfoButtonText, seeMoreInfoButtonText = _b === void 0 ? 'ver mais informações' : _b, _c = _a.seeMoreInfoModalTitleText, seeMoreInfoModalTitleText = _c === void 0 ? 'mais informações' : _c, props = __rest(_a, ["rows", "columns", "seeMoreInfoButtonText", "seeMoreInfoModalTitleText"]);
    var rowsWithSlicedData = rows.map(function (_a) {
        var data = _a.data, rest = __rest(_a, ["data"]);
        return (__assign(__assign({}, rest), { data: data.slice(0, MAX_VISIBLE_ITEMS) }));
    });
    return (React.createElement(Wrapper, __assign({ ref: ref }, props), rowsWithSlicedData.map(function (_a, index) {
        var key = _a.key, data = _a.data, detailedContent = _a.detailedContent;
        return (React.createElement(Card, { rawRows: rows, key: key, data: data, columns: columns, detailedContent: detailedContent, index: index, seeMoreInfoButtonText: seeMoreInfoButtonText, seeMoreInfoModalTitleText: seeMoreInfoModalTitleText }));
    })));
});

export { MAX_VISIBLE_ITEMS, Table as default };
